import {UseMutateFunction} from '@tanstack/react-query';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {ISlide} from '../../../../incase-domain/slide';
import {resetPresentationReducerAction} from '../../../../store/actions/presentation';
import {deletedEmittedSharedPresentationSelector, selectedPresentationSelector} from '../../../../store/selectors/presentation.selectors';
import EmittedSlideModal from '../../../components/common/modal/EmittedSlideModal';
import SelectedElementModal from '../../../components/common/modal/SelectedElementModal';
import ConfirmModal from '../../../../incase-domain/components/modals/confirmModal/ConfirmModal';

interface ModalsProps {
    emittedSlideModal: boolean;
    setEmittedSlideModal: (open: boolean) => void;
    mutateSlide: UseMutateFunction<void, unknown, {slide: ISlide; isRejected?: boolean}, unknown>;
    emittedSharedPresentationModal: boolean;
    setEmittedSharedPresentationModal: (open: boolean) => void;
}

function Modals(props: ModalsProps): JSX.Element {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const {emittedSlideModal, setEmittedSlideModal, mutateSlide} = props;
    const {emittedSharedPresentationModal, setEmittedSharedPresentationModal} = props;

    const navigate = useNavigate();

    const selectedPresentation = useSelector(selectedPresentationSelector);
    const deletedEmittedSharedPresentationIds = useSelector(deletedEmittedSharedPresentationSelector);

    function emittedSharedPresentationModalEventHandler(): void {
        navigate('/presentations/shared');
        setEmittedSharedPresentationModal(false);
        dispatch(resetPresentationReducerAction());
    }

    return (
        <>
            <SelectedElementModal />

            <EmittedSlideModal
                emittedSlideModal={emittedSlideModal}
                cancelEmittedSlideModal={() => setEmittedSlideModal(false)}
                mutateSlide={mutateSlide}
            />

            <ConfirmModal
                isOpen={emittedSharedPresentationModal}
                color="warning"
                onCancel={emittedSharedPresentationModalEventHandler}
                onConfirm={emittedSharedPresentationModalEventHandler}
                title={t('loginPage.modal.blockPresenter.header')}
                message={t(
                    `presEditPage.settings.sharedPresentations.${
                        deletedEmittedSharedPresentationIds.includes(selectedPresentation._id)
                            ? 'deletedEmittedSharedPresModalTitle'
                            : 'emittedSharedPresModalTitle'
                    }`
                )}
                showConfirm
                confirmText="OK"
            />
        </>
    );
}

export default Modals;
